var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":_vm.place,"width":_vm.width,"trigger":_vm.trig,"popper-class":_vm.cls}},[_vm._t("reference",null,{"slot":"reference"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }